<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g>
      <g>
        <path
          d="M3.3192,7.37817C3.0124500000000003,7.06082,3.23733,6.53067,3.6787,6.53067L7,6.53067L7,2L9,2L9,6.53067L12.3213,6.53067C12.7627,6.53067,12.9875,7.06082,12.6808,7.37817L8.353539999999999,11.8549C8.158280000000001,12.0502,7.8417,12.0502,7.64644,11.8549L3.3192,7.37817ZM3,11L3,13L13,13L13,11L14,11L14,13C14,13.5523,13.5523,14,13,14L3,14C2.44772,14,2,13.5523,2,13L2,11L3,11Z"
          fill="currentColor"
          fill-opacity="1"
        />
      </g>
    </g>
  </svg>
</template>
